import React, { useState } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons'
import Form from '../components/form'

config.autoAddCss = false

const Contact = () => {
  const [name, setName] = useState('{Name}')
  const [project, setProject] = useState('{Projekt}')
  const [contact, setContact] = useState('{Kontaktmöglichkeit}')

  const handleChange = (property, value) => {
    switch (property) {
      case 'name':
        value === '' ? setName('{Name}') : setName(value)
        return
      case 'project':
        value === '' ? setProject('{Projekt}') : setProject(value)
        return
      case 'contact':
        value === '' ? setContact('{Kontaktmöglichkeit}') : setContact(value)
        return
      default:
        return
    }
  }

  return (
    <Container fluid className="contact-bg h-700" id="kontakt">
      <Row>
        <div className="col-12 mt-5 px-3">
          <div className="container bg-white shadow" style={{ position: 'relative', top: '-40%' }}>
            <div className="row">
              <Col className="col-10 offset-1">
                <div className="row mt-5 mb-5 pt-5 pb-3">
                  <div className="col-12 mb-5">
                    <h2>Lernen Sie uns kennen!</h2>
                  </div>
                  <div className="col-12 col-md-6">
                    <Form onChange={handleChange} />
                  </div>
                  <div className="col-12 col-md-5 offset-md-1 mt-5 mt-md-0">
                    <span id="mailcontent">
                      <p>
                        <strong>Hallo ganztags.</strong>
                      </p>
                      <p>
                        mein Name ist <span id="name">{name}</span> und ich benötige Hilfe mit{' '}
                        <span id="projekt">{project}</span>. Bitte kontaktiert mich unter{' '}
                        <span id="email">{contact}</span>.
                      </p>
                    </span>
                    <p className="mt-3 pt-3 pb-5 mb-5">
                      Alternativ schreiben Sie uns direkt eine Mail an hallo@ganztags.net.*
                    </p>
                    <p className="small mt-5 pt-5 mb-0">
                      *Telefonisch sind wir bei Erstkontakt nicht erreichbar. Nachdem uns neulich das Farbband für das Fax ausgegangen ist, haben wir die Telefone gleich mit entsorgt. Ein direkter Austausch per Meets, Zoom o.ä. ist aber natürlich kein Problem.
                    </p>
                  </div>
                </div>
              </Col>
            </div>
          </div>
        </div>
      </Row>
    </Container>
  )
}

export default Contact
